import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      deletingTemplates: 'messageTemplates/getDeletingTemplates',
    }),
  },

  methods: {
    isTemplateDeleting(id) {
      return this.deletingTemplates.includes(id);
    },
  },
};
